import { useQuery } from '@tanstack/react-query'
import { fetchOnboardingAdvisoryStatusV2, selectEliteOnboardingFromAdvisoryAxios } from '../../../repository/misc'
import type { EliteOnboardingStatusResponse } from '../../../types/misc.types'

export function useEliteOnboardingAdvisoryStatus(queryKey: string) {
  return useQuery<any, Error, EliteOnboardingStatusResponse | undefined>({
    queryKey: [queryKey],
    queryFn: fetchOnboardingAdvisoryStatusV2,
    select: selectEliteOnboardingFromAdvisoryAxios,
    retry: 1,
    refetchOnWindowFocus: false
  })
}
